import Awards from './Main'
import { getBaseMetaTitle } from '@/environments'

const route = {
  path: '/awards',
  name: 'awards',
  meta: {
    title: `Awards - ${getBaseMetaTitle}`
  },
  component: Awards
}

export default route
